export default __webpack_public_path__ + "static/media/rick.0ba92b9f.jpg";